import { Page } from '@app/components/page/Page';
import { UserIcon } from '@app/components/users/UserIcon';
import { useAuthContext } from '@app/core/auth/authentication/context';
import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { useLocale } from '@app/core/hooks/useLocale';
import { useToast } from '@app/core/notifications';
import { useSetLocale } from '@app/core/user-settings/stores/user-settings.store';
import { updateUser } from '@app/modules/admin/api';
import { useIntl } from 'react-intl';
import { UserSettingsValues } from './user-settings.schema';
import { UserSettingsForm } from './UserSettingsForm';

export const UserSettingsPage = () => {
  const { formatMessage } = useIntl();
  const { notifyError } = useToast();
  const setLocale = useSetLocale();
  const { updateAuthUser } = useAuthContext();

  const title = formatMessage({
    id: 'settings.userSettings.title',
    defaultMessage: 'Configuración de usuario',
  });

  const onSubmit = async (data: UserSettingsValues) => {
    try {
      await updateUser(user.id, {
        name: data.name,
        surname: data.surname,
        language: data.language,
      });

      updateAuthUser({
        name: data.name,
        surname: data.surname,
        language: data.language,
      });

      setLocale(data.language);
    } catch (error) {
      notifyError(
        formatMessage({
          id: 'common.errorOccurredTryAgain',
          defaultMessage: 'Ocurrió un error, intenta nuevamente',
        }),
      );
    }
  };

  const { user } = useAuth();

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<UserIcon />} title={title} />
      <Page.Content>
        <UserSettingsForm
          values={{
            name: user.name,
            surname: user.surname,
            language: useLocale(),
          }}
          onSubmit={onSubmit}
        />
      </Page.Content>
    </Page>
  );
};
